import React, { useEffect } from "react"
import { BuilderComponent } from "@builder.io/react"
import type { BuilderContent } from "@builder.io/sdk" // This is what the react sdk is using under the hood

import Seo from "~components/shared/seo"
import { TEST_IDS } from "~config/test-ids"
import { useGlobalNavigation } from "~config/global-navigation-provider"
import { useSetHubspotChatVisibility } from "~utils/hubspot-hooks"

type Props = {
    readonly title?: string | null
    readonly description?: string | null
    readonly shouldHideHeader?: boolean | null
    readonly shouldHideFooter?: boolean | null
    readonly shouldHideChat?: boolean | null
    readonly metaImage?: string | null
    readonly content: BuilderContent
    readonly model: BuilderModel
    readonly noIndex?: boolean | null
}

export default function BuilderGenericPage({
    title,
    description,
    shouldHideHeader,
    shouldHideFooter,
    shouldHideChat,
    metaImage,
    content,
    model,
    noIndex,
}: Props) {
    const { setGlobalNavigation } = useGlobalNavigation()

    useEffect(() => {
        setGlobalNavigation({
            isHeaderHidden: shouldHideHeader ?? false,
            isFooterHidden: shouldHideFooter ?? false,
        })
    }, [shouldHideHeader, shouldHideFooter])

    useSetHubspotChatVisibility({
        shouldShow: !shouldHideChat,
        shouldOpen: false,
    })

    return (
        <>
            <Seo
                title={title}
                description={description}
                image={metaImage}
                isNoIndex={Boolean(noIndex)}
            />
            <div data-testid={TEST_IDS.BUILDER_COMPONENT}>
                <BuilderComponent
                    model={model}
                    content={content}
                    options={{ includeRefs: true, enrich: true }}
                />
            </div>
        </>
    )
}

export enum BuilderModel {
    Page = "page",
    Blog = "blog",
}
